module.exports = __webpack_public_path__ + "img/account-operations.67e2d6ce.png";